var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bread-crumb',{attrs:{"location":"products"}}),_c('top-area'),_vm._v(" "),_c('list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }